import { useEffect, useState } from 'react'

const USER_INPUT_DEBOUNCE_TIME = 300

export const useDebouncedInput = (
  input: string,
  debounceTime = USER_INPUT_DEBOUNCE_TIME
) => {
  const [isDebouncing, setIsDebouncing] = useState(false)
  const [debouncedValue, setDebouncedValue] = useState(input)

  useEffect(() => {
    setIsDebouncing(true)
    const handler = setTimeout(() => {
      setDebouncedValue(input)
      setIsDebouncing(false)
    }, debounceTime)
    return () => {
      clearTimeout(handler)
    }
  }, [input, debounceTime])

  return { debouncedValue, isDebouncing }
}
